import makeStyles from '@ui/utils/makeStyles';

export default makeStyles()((theme) => ({
  headerText: {
    fontSize: 24, 
    fontWeight: 600, 
    lineHeight: 1.3, 
    marginTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      fontSize: 60,
    }
  },
  stagingQuoteButton: {
    width: '100%',
    marginTop:theme.spacing(2),
    textAlign: 'center',
    fontSize: 14,
    [theme.breakpoints.up('lg')]: {
      marginTop: theme.spacing(11.5)
    }
  },
  infoNum: {
    color: '#161d1e',
    lineHeight: 1,
    fontWeight: 400,
    fontSize: 36,
    position: 'relative',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      fontSize: 60,
      marginTop: theme.spacing(7)
    }
  },
  infoWrapper: {
    paddingTop: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(7)
    }
  },
  infoHeader: {
    fontSize: 16,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      fontSize: 24,
      marginBottom: 0
    }
  },
  infoText: {
    color: '#666',
    fontSize: 14,
    lineHeight: 1.4,
    [theme.breakpoints.up('md')]: {
      fontSize: 16
    }
  },
  divider: {
    border: '1px solid', 
    marginTop: theme.spacing(5)
  },
}));
